import React from 'react';

import {
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
} from '@/shared/assets/icons/checkbox-icon';
import { TCheckboxProps } from '@/shared/components/ui/checkbox/checkbox.types';
import { StyledRadio } from '@/shared/components/ui/form/components/radio/radio.styled';

export const Radio: React.FC<TCheckboxProps> = ({ size, ...props }) => {
  return (
    <StyledRadio
      {...props}
      $size={size}
      icon={<CheckboxUncheckedIcon />}
      checkedIcon={<CheckboxCheckedIcon />}
    />
  );
};
